export class Constants {
  static WRONGEMAIL = 'WRONGEMAIL';
  static NOEMAIL = 'NOEMAIL';
  static INTERNAL = 'INTERNAL';
  static MISSINGUSER = 'MISSINGUSER';
  static APPLICATIONNAME = 'swiftDizzee';
  static EXTAPPNAME = 'swiftConsumption';
  static EXTAPPTRENDS = 'swiftTrends';
  static DOMAINNAME = 'umusic.com';
  static INTERNALDOMAINS = ['umusic.com' , 'fictionrecords.com', 'caroline.com', 'abbeyRoad.com',
  'copenhagenrecords.dk', 'bravado.com', 'umusic.ca',
  'virgin-records.de', 'umgtemp.com', 'spinefarmrecords.com',
  'astralwerks.com', 'eagle-rock.com', 'cphmusic.dk', 'digster.fm', 'famehouse.net',
  'digitalstores.co.uk', 'universalmusic.com.au', 'eaglerockent.com', 'harvestrecords.com'];
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src?&aot=true&genDir=compiled!./~/tslint-loader!./src/app/helpers/constants.ts